// Import jQuery for DOM manipulation
import $ from 'jquery';

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.CompanyTemplates = {
  initializeIssueTypeTemplatesGrid(tableSelector, issueTypeTemplates) {
    const gridOptions = {
      paginationPageSize: 10,
      headerHeight: 44,
      rowHeight: 44,
      columnDefs: this._columnDefs(),
      rowData: issueTypeTemplates,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      onGridSizeChanged(event) {
        return event.api.sizeColumnsToFit();
      },
      onGridReady(event) {
        event.api.sizeColumnsToFit();
        return $('[data-powertip]').powerTip();
      }
    };

    const gridDiv = document.getElementById(tableSelector);
    const gridApi = agGrid.createGrid(gridDiv, gridOptions);
    gridOptions.api = gridApi;
    resizeAgGridTable(`#${tableSelector}`, gridOptions, 1);
    gridApi.sizeColumnsToFit();
    const activeTemplateId = _.find(issueTypeTemplates, { active: true }).id;
    return this._listenToActiveRadioButtonChange(activeTemplateId);
  },

  initializeDocumentRequirementTemplatesGrid(tableSelector, documentRequirementTemplates) {
    const gridOptions = {
      paginationPageSize: 10,
      headerHeight: 44,
      rowHeight: 44,
      columnDefs: this._documentColumnDefs(),
      rowData: documentRequirementTemplates,
      defaultColDef: {
        sortable: true
      },
      onGridSizeChanged(event) {
        return event.api.sizeColumnsToFit();
      }
    };

    const gridDiv = document.getElementById(tableSelector);
    const gridApi2 = agGrid.createGrid(gridDiv, gridOptions);
    gridOptions.api = gridApi2;
    resizeAgGridTable(`#${tableSelector}`, gridOptions, 1);
    return gridApi2.sizeColumnsToFit();
  },

  initializeTemplateShow(json) {
    return initializeChecklist($('#template-issues')[0], { issue_types: json });
  },

  initializeModals() {
    $(document).on('change', '#add-company-templates-input', _.bind(this._showFileName, this));
    return $(document).on('click', '.file_upload_cancel', _.bind(this._resetFileInputField, this));
  },

  _resetFileInputField(event) {
    $('#add-company-templates-input').val('');
    $('.uploadrow').addClass('hide');
    $('#create_template_btn').addClass('disabled');
    return $('.file_upload_name').text('');
  },

  _showFileName(event) {
    const $target = $(event.currentTarget);

    const fileName = $target[0].files[0].name;

    $('.uploadrow').removeClass('hide');
    $('#create_template_btn').removeClass('disabled');
    return $('.file_upload_name').text(fileName);
  },

  _showFlashSuccessMessage(message) {
    $('.alert-box').remove();
    const flashMessage = '<div class="alert-box nomargin success" data-alert>' + message +
      '<a class="close"><i class="pti pt-cancel" href="#"></i></a>' +
      '</div>';
    return $('body').append(flashMessage);
  },

  _columnDefs() {
    return [
      { headerName: I18n.t('v4.issue_templates.default'), cellClass: 'cell', cellRenderer: this._renderDefaultRadioButton },
      { headerName: I18n.t('name'), field: 'name', cellClass: 'cell' },
      {
        headerName: I18n.t('v4.issue_templates.current_user'), cellClass: 'cell', children: [
          { headerName: I18n.t('v4.issue_templates.documents'), field: 'documents_count' },
          { headerName: I18n.t('v4.issue_templates.projects'), field: 'projects_count' }
        ]
      },
      {
        headerName: 'Create', cellClass: 'cell', children: [
          { headerName: I18n.t('v4.issue_templates.user'), field: 'user' },
          { headerName: 'Date', field: 'created_at', cellRenderer: this._dateRenderer },
          { headerName: I18n.t('actions'), width: 100, sortable: false, suppressSizeToFit: true, cellRenderer: this._renderActions },
        ]
      }
    ];
  },

  _documentColumnDefs() {
    return [
      { headerName: I18n.t('name'), field: 'name', cellClass: 'cell' },
      { headerName: I18n.t('actions'), width: 100, sortable: false, suppressSizeToFit: true, cellRenderer: this._renderDocumentActions }
    ];
  },

  _listenToActiveRadioButtonChange(activeTemplateId) {
    return $('input[type=radio].active').on('change', e => $('#new_issue_type_template').exists().submit());
  },

  _renderDefaultRadioButton(params) {
    return `<input type='radio' class='active' name='active_template_id' value='${params.data.id}' ${params.data.active ? 'checked' : undefined}/>`;
  },

  _dateRenderer(params) {
    const date = moment(params.data.created_at);
    if (date.isValid()) { return date.format('MMMM D, YYYY'); } else { return ''; }
  },

  _renderActions(params) {
    const CSRFToken = $('meta[name="csrf-token"]').attr('content');
    return "<div class='row-actions'>" +
      `<span data-powertip='${I18n.t('delete')}'>
<form class='inline nomargin' method='post' action='/company_settings/issue_templates/${params.data.id}'>
<input type='hidden' name='_method' value='delete'/>
<input type='hidden' name='authenticity_token' value='${CSRFToken}'/>
<button class='button nano icon-btn pt-delete' data-confirm='${'Confirm'}'></button>
</form>
</span>` +
      `<span data-powertip='${'Export'}'>
<a class='button nano icon-btn pt-download' href='${params.data.download_url}'></a>
</span>` +
      `<span data-powertip='${'View'}'>
<a class='button nano icon-btn pt-view' href='/company_settings/issue_templates/${params.data.id}'></a>
</span>` +
      "</div>";
  },

  _renderDocumentActions(params) {
    const CSRFToken = $('meta[name="csrf-token"]').attr('content');
    return "<div class='row-actions'>" +
      `<span data-powertip='${I18n.t('delete')}'>
<form class='inline nomargin' method='post' action='/company_settings/document_requirement_templates/${params.data.id}'>
<input type='hidden' name='_method' value='delete'/>
<input type='hidden' name='authenticity_token' value='${CSRFToken}'/>
<button class='button nano icon-btn pt-delete' data-confirm='${'Confirm'}'></button>
</form>
</span>` +
      `<span data-powertip='${I18n.t('edit')}'>
<a class='button nano icon-btn pt-edit' href='/company_settings/document_requirement_templates/${params.data.id}/edit'></a>
</span>` +
      "</div>";
  }
};
